// import '../internals/custom-jquery';
// import '../internals/global';
 import './components/kg-rdv';

/**
 * Function utilisée sur le formulaire "Mon rendez-vous"
 */

 (function(w) {
    w.Completude = Object.assign({},w.Completude, { RendezVous : {}});
    /**
     * Initialisation du formulaire
     */
    w.Completude.RendezVous.initFormulaire = function() {                              
        
        Completude.RendezVous.SecurityKey =   (new RegExp("\/mon-rendez-vous\/([^\/]+)\/?","g")).exec(document.location)[1];
        
        var etapecourante =0;
        
        if (typeof(Completude_RendezVous.DateRendezVous)!=='undefined' && Completude_RendezVous.DateRendezVous!==null) {
            // Si une DateDeRendezVous est déjà positionné , on passe directement à l'étape 2
            etapecourante =1;
            // Modifie le message success
            $("#etape_confirmation_rdv .success-message h6").html(  "RDV confirmé</br>" + Completude.AcfKgRdv.GetDateRdv(Completude_RendezVous.DateRendezVous) );
            $("#etape_confirmation_annulation .success-message h6").html( "RDV annulé</br>" + Completude.AcfKgRdv.GetDateRdv(Completude_RendezVous.DateRendezVous) );
        } 

        // Active la gestion des étapes (library Steps.js)        
        Completude.RendezVous.steps = new Steps({
            steps: '[data-step-index]',
            progress : '.progress-step',                     
            container: document.querySelector('#section-mon-rendez-vous'),
            backNavigator : true
        });

        Completude.RendezVous.steps.to(etapecourante);

        //Capte l'évènement de validation de la date et l'heure de rendez-vous
        $("#etape_date .acf-rdv").on("acf-field-type-rdv-validation-rdv",function() {
            // Modifie le message success
            var dateRdv = Completude.AcfKgRdv.GetDateRdv($("input[name=rdv_date]:checked").val());
            $("#etape_confirmation_rdv .success-message h6").html(  "RDV confirmé</br>" + dateRdv );
            // Modifie le message success
            $("#etape_confirmation_annulation .success-message h6").html( "RDV annulé</br>" + dateRdv);

            // Passe à l'étape suivante 
            var dataRdv =  {
                action : 'ajax_valider_rdv',    
                rdv_date : $("input[name=rdv_date]:checked").val(),
                SecurityKey :  Completude.RendezVous.SecurityKey };                                          
                
            
            $('#etape_date').loading(
                $.ajax({
                    url: disko_ajax_object.ajaxurl,
                    type: 'post',
                    data: dataRdv,
                    success: function success(response) {
                        if (response.success) {                                
                            Completude.RendezVous.steps.next();
                            Completude.TagManagerTunnel();
                            document.querySelector('body').scrollIntoView();                                
                        } else {                            
                            $('.loader').hide();                            
                        }
                        return false;
                    }
                }).promise()
            );
                          
        })

        // // Capte l'évènement Généré par Kinougarde.formulaireAcf.NextStep(); lors de la validation de la date et de l'heure (avant l'appel Ajax)                
        // $("#etape_date").on("form-step-next-change",function(event, options) {
        //     // Ajoute la clé de sécurité contenu dans l'url                      
        //     options.data = {"SecurityKey": Kinougarde.RendezVous.SecurityKey};            
        //     return options;
        // });

        // Click sur le bouton "Déplacer mon RDV"
        $("#bouton_deplacer_rdv").on('click',function(e) {
            e.preventDefault();
            
            // Appel Ajax pour vérifier si l'utilisateur n'a pas été intégré entre temps
            $('#etape_confirmation_rdv .form__step-content').loading(
                $.ajax({
                    type     : 'POST',
                    dataType : 'json',
                    url      : disko_ajax_object.ajaxurl,
                    data     : {action : 'ajax_deplacer_rdv',SecurityKey : Completude.RendezVous.SecurityKey},
                    success  : function (reponse) {                         
                        if (reponse.data.redirect===false) {
                            // ON reste sur le site
                            Completude.RendezVous.steps.prev();
                        } else {
                            // On part sur l'extranet prod
                            document.location.href = reponse.data.redirect;
                        }                    
                } }).promise()
            );            
            return false;
        });

        //Click sur le bouton "Annuler mon RDV"
        $("#bouton_annuler_rdv").on('click',function(e) {
            
            e.preventDefault(); 
           
            // Appel Ajax pour vérifier si l'utilisateur n'a pas été intégré entre temps            
            $('#etape_confirmation_rdv .form__step-content').loading(
                $.ajax({
                    type     : 'POST',
                    dataType : 'json',
                    url      : disko_ajax_object.ajaxurl,
                    data     : {action : 'ajax_deplacer_rdv',SecurityKey : Completude.RendezVous.SecurityKey},
                    }).then(function(reponse) {
                    if (reponse.data.redirect===false) {
                        // ON reste sur le site, on annule le RDV puis on passe à l'étape suivante
                        return $.ajax({
                            type     : 'POST',
                            dataType : 'json',
                            url      : disko_ajax_object.ajaxurl,
                            data     : {action : 'ajax_annuler_rdv',SecurityKey : Completude.RendezVous.SecurityKey},
                            success  : function (r2) { 
                                    // Le RDV est Annulé
                                    Completude.RendezVous.steps.next();
                                    Completude.TagManagerTunnel();
                            }});                        
                                                
                    } else {
                        // On part sur l'extranet prod
                        document.location.href = reponse.data.redirect;
                    }
                }).promise()
            );;            
            return false;            
        });

         //Click sur le bouton "Prendre un RDV"
         $("#bouton_prendre_rdv").on('click',function(e) {
            //Retourne sur la première étape                                               
            e.preventDefault();
            $('#etape_confirmation_annulation .form__step-content').loading();
            document.location.reload();            
            return false;    
        });

        // Mise à jour des infos de l'agence        
        if (typeof(Completude_RendezVous.Agence)!=='undefined' && Completude_RendezVous.Agence!==null) {
            Completude.UpdateAgence(Completude_RendezVous.Agence);
        }

        // Envoi du tracking de l'étape 1
        Completude.TagManagerTunnel();
                                                         
    };    
    
})(window);

jQuery(function() {
    try {
    if (jQuery("#section-mon-rendez-vous").length>0) {               
        Completude.RendezVous.initFormulaire();        
    };   
    }     
    catch (ex) {
        console.error(ex);
    }
});